import {EventEmitter, Injectable} from '@angular/core';
import {ApiClientService} from './api-client.service';
import {NetworkEntity, SettingsSms} from '../types/data.types';
import {UrlService} from './url.service';
import {EmptyRowService} from './empty-row.service';
import {EmailService} from './email.service';
import {AccountPermissionsService} from './account-permissions.service';
import {Observable} from 'rxjs/Observable';
import {tap} from 'rxjs/operators';
import {createInitialNetworkEntity, resolveNetworkEntity} from './helper-functions';

declare const $: any;

@Injectable()
export class SettingsSmsService {
    showCreateModal = false;
    showDetailedView = true;
    selectedItemData: SettingsSms;
    spinnerShow = false;
    corporations: any = {
        data: [],
        total: null
    };
    modalSpinnerShow = false;
    showServiceUnavailable = false;
    serviceName: string = 'sms';
    onDetailedViewToggle: EventEmitter<any> = new EventEmitter();

    constructor(public es: EmailService,
                public api: ApiClientService,
                public urlService: UrlService,
                public emptyRowService: EmptyRowService,
                public account: AccountPermissionsService
    ) {
    }

    getCorporations(scrollToTop?): void {
        this.getCorporationsByQueryParams(scrollToTop).subscribe();
    }

    getCorporationsByQueryParams(scrollToTop?): Observable<NetworkEntity<any>> {
        this.showServiceUnavailable = false;
        let queryParams = this.urlService.getQueryParamsString();
        if (queryParams && queryParams.indexOf('&order-by=') != -1)
            queryParams = queryParams.slice(0, queryParams.indexOf('&order-by='));
        const url = `/v1/corporation_number.json?${queryParams}&expand=buildings`;
        return this.api.getJson('domainBD', url)
            .pipe(
                createInitialNetworkEntity(),
                resolveNetworkEntity(),
                tap(({loading}) => this.spinnerShow = loading),
                tap(
                    (res) => {
                        this.corporations.data = res.entities;
                        this.corporations.total = res.total;
                        this.emptyRowService.fillEmptyRow();
                        if ($('.table')[0] && scrollToTop)
                            $('.table')[0].scrollIntoView();
                    },
                    (error) => {
                        this.showServiceUnavailable = true;
                        this.spinnerShow = false;
                        this.api.errorHandler(error, 'Failed get corporations');
                    }
                )
            );
    }

    resetData() {
        this.corporations.data = [];
        this.corporations.total = null;
    }

    toggleDetailedView(data, state: boolean): void {
        this.selectedItemData = data ? data : null;
        this.corporations.data.forEach(item => item.checked = false);
        if (state) {
            data.checked = true;
            this.getSettingsForCorporation(data.id);
            this.onDetailedViewToggle.emit();
        }
        this.showDetailedView = state;
    }

    canEdit(buildingId?: number) {
        return this.account.canUpdate(this.serviceName, buildingId);
    }

    canDelete(buildingId?: number) {
        return this.account.canDelete(this.serviceName, buildingId);
    }

    getSettingsForCorporation(corporationNumberId) {
        const corporationName = (<any>this.selectedItemData).name;
        this.selectedItemData = null;

        const url = `/v1/cn_settings/${corporationNumberId}.json`;
        this.api.get('domainSms', url).subscribe(
            res => {
                const body = JSON.parse(res._body);
                this.selectedItemData = body ? this.settingsSmsFactory(body) : new SettingsSms();
                this.selectedItemData.corporationNumberName = corporationName;
            },
            error => {
                if (error.statusText == 'Not Found') {
                    this.selectedItemData = new SettingsSms();
                    this.selectedItemData.corporationNumberName = corporationName;
                } else
                    this.api.errorHandler(error, 'Failed to get sms settings for the chosen corporation');
            }
        );
    }

    settingsSmsFactory(setting) {
        const smsSetting = new SettingsSms();

        if (setting.id) smsSetting.id = setting.id;
        if (setting.corporationNumberId) smsSetting.corporationNumberId = setting.corporationNumberId;
        if (setting.twilioSettings) smsSetting.twilioSettings = setting.twilioSettings;
        if (setting.createdAt) smsSetting.createdAt = setting.createdAt;
        if (setting.isEnable) smsSetting.isEnable = setting.isEnable;

        return smsSetting;
    }
}



// WEBPACK FOOTER //
// /app/src/app/services/settings-sms.service.ts